import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function ErrorCard() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Card
        sx={{
          maxWidth: 400,
          textAlign: 'center',
          boxShadow: 3,
        }}
      >
        <CardContent>
          <ErrorOutlineIcon
            sx={{
              fontSize: 60,
              color: 'error.main',
              mb: 2,
            }}
          />
          <Typography variant="h5" component="div" color="error" gutterBottom>
            Error
          </Typography>
          <Typography variant="body1">
            No tiene permiso para esta sección.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}